import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getArticleProofsOptions,
  useDeleteArticleProof,
  useUploadOrUpdateArticleProof,
} from './model/ArticleProofModel';

interface ArticleProofActionProps {
  articleId: number;
  authors: Author[];
  variant?: 'compact';
}

export function ArticleProofAction({ articleId, authors }: ArticleProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getArticleProofsOptions(articleId));
  const uploadOrUpdateMutation = useUploadOrUpdateArticleProof(articleId);
  const deleteMutation = useDeleteArticleProof(articleId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="article"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
